import classNames from 'classnames/bind';
import React, { ReactNode } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { LinkAppearance } from './LinkGroup.constants';
import styles from './LinkGroup.module.scss';

export interface LinkGroupProps {
  routes: LinkGroupRoute[];
  onRouteClick?: () => void;
  linkMode?: LinkAppearance;
}

export interface LinkGroupRoute extends Pick<NavLinkProps, 'end'> {
  label: string;
  to: string;
  dataTestId?: string;
  icon?: ReactNode;
  isBeta?: boolean;
}

const cx = classNames.bind(styles);

const LinkGroup = ({ routes, onRouteClick, linkMode = LinkAppearance.Primary }: LinkGroupProps): React.ReactElement => {
  return (
    <div className={cx('body')}>
      {routes.map((route) => (
        <NavLink
          end={route.end}
          to={route.to}
          key={route.to}
          className={({ isActive }) => cx('link', `${linkMode}`, { active: isActive })}
          data-testid={route.dataTestId}
          onClick={onRouteClick}
        >
          {route.icon && <span className={cx('icon')}>{route.icon}</span>}
          {route.label}
          {route.isBeta && <span className={cx('beta')}>BETA</span>}
        </NavLink>
      ))}
    </div>
  );
};

export default LinkGroup;
